import { GridFields } from 'components';
import { styled } from 'libs/ui/styled';

interface Props {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
}

const ContentStyled = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: `1fr 3fr`,
  alignItems: 'center',
  padding: '24px 0',
  gap: 24,
}));

export const SettingsContent = ({ leftContent, rightContent }: Props) => (
  <ContentStyled>
    {leftContent} <GridFields>{rightContent}</GridFields>
  </ContentStyled>
);
